import { useTranslation } from 'react-i18next'

import { PlusIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, ButtonWithSpinner, CardTitle, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import ViewVisibilityFields from '@/common/components/FilterViews/ViewVisibilityFields/ViewVisibilityFields'

import useCreateViewForm from './hooks/useCreateViewForm/useCreateViewForm'
import { viewNameMaxLength } from './constants'
import * as Styles from './styles'

const CreateViewForm = ({
  initialName,
  groups,
  fixedGroupIds,
  canSelectGroups,
  loadingGroups,
  saving,
  onCancel,
  onSave,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const {
    name,
    handleChangeName,
    visibility,
    setVisibility,
    selectedGroupIds,
    toggleGroup,
    selectedGroups,
    showSharedGroupsAlert,
    showGroupsWithAccess,
    isFormValid,
    handleSave,
  } = useCreateViewForm({ initialName, groups, fixedGroupIds, canSelectGroups, onSave })

  return (
    <Styles.Container>
      <CardTitle Icon={PlusIcon}>{t('Crear nueva vista')}</CardTitle>
      <Styles.Content>
        <Styles.NameSection>
          <Text type="bodyMRegular" color={theme.colors.text.muted}>
            {t('Ponle un nombre para que tu equipo pueda identificarla')}
          </Text>
          <InputWithLabel
            label={t('Nombre interno')}
            value={name}
            onChange={handleChangeName}
            maxLength={viewNameMaxLength}
            fullWidth
          />
        </Styles.NameSection>
        <ViewVisibilityFields
          visibility={visibility}
          onChangeVisibility={setVisibility}
          groups={groups}
          selectedGroupIds={selectedGroupIds}
          fixedGroupIds={fixedGroupIds}
          selectedGroups={selectedGroups}
          showSharedGroupsAlert={showSharedGroupsAlert}
          showGroupsWithAccess={showGroupsWithAccess}
          loadingGroups={loadingGroups}
          onToggleGroup={toggleGroup}
        />
      </Styles.Content>
      <Styles.Footer>
        <Button variant="outlined" fullWidth onClick={onCancel}>
          {t('Cancelar')}
        </Button>
        <ButtonWithSpinner
          fullWidth
          onClick={handleSave}
          defaultLabel={t('Guardar')}
          loadingLabel={t('Guardando')}
          loading={saving}
          disabled={saving || !isFormValid}
        />
      </Styles.Footer>
    </Styles.Container>
  )
}

export default CreateViewForm
